<button
  type="button"
  class="ai-assist-button"
  [attr.aria-label]="'page.artificialIntelligence.assistButton' | translate"
  [matTooltip]="'page.artificialIntelligence.assistButton' | translate"
  (click)="assistClick.emit()"
>
  <img class="ai-assist-icon" src="assets/images/action-tracker-ai-icon-animated.svg" alt="" />
</button>
